import styled, { keyframes, css } from "styled-components";

import { whiteBgOnClickAnim } from "../../animations";

const perfectWin = keyframes`
  0% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.4,1,0,0);
  }
  16% {
    transform: scale(0.5);
    animation-timing-function: cubic-bezier(0.4,0,0,1);
  }
  30% {
    transform:scale(1);
  }
`;

const midExplode = keyframes`
  0% {
    transform: translateX(0) translateY(0)  scale(1);
  }
  21% {
    transform: translateX(0px) translateY(0px)  scale(0.5);
    animation-timing-function: cubic-bezier(0.33,0,0,1);
  }
  34% {
    transform: translateX(-12px) translateY(0px)  scale(0.9);
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
  }
  39% {
    transform: translateX(-8px) translateY(-8px)  scale(1);
    animation-timing-function: cubic-bezier(0,0,0,1);
  }
  47% {
    transform: translateX(12px) translateY(-12px) scale(1);
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
  }
  60% {
    transform: translateX(-12px) translateY(0) scale(1);
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);

  }
  73% {
    transform: translateX(12px) translateY(0px) scale(1);
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
  }
  86% {
    transform: translateX(-12px) translateY(-12px) scale(1);
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1);
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
  }

`;
const topExplode = keyframes`
0% {
    transform: translateX(0) translateY(0)  scale(1);
    animation-timing-function: cubic-bezier(0.4,1,0,0);
  }
  16% {
    transform: translateX(-2px) translateY(0px)  scale(0.5);
    animation-timing-function: cubic-bezier(0.4,0,0,1);
  }
  26% {
    transform: translateX(-12px) translateY(0px) scale(1);
  }
  36% {
    transform: translateX(12px) translateY(0px) scale(1);
  }
  46% {
    transform: translateX(-10px) translateY(0px) scale(1);
  }
  56% {
    transform: translateX(10px) translateY(0px) scale(1);
  }
  66% {
    transform: translateX(-8px) translateY(0px) scale(1);
  }
  76% {
    transform: translateX(0px) translateY(0px) scale(1);
  }
  
`;
const leftExplode = keyframes`
   0% {
    transform: translateX(0px) translateY(0px) scale(1);
  }
  21% {
    transform: translateX(8px) translateY(0px) scale(0.5);
    animation-timing-function: cubic-bezier(0.33,0,0,1);
  }
  34% {
    transform: translateX(12px) translateY(-2px) scale(1);
    animation-timing-function: cubic-bezier(0,0,0,1);
  }
  47% {
    transform: translateX(8px) translateY(-12px) scale(1);
    animation-timing-function: linear;
  }
  60% {
    transform: translateX(8px) translateY(-8px) scale(1);
    animation-timing-function: linear;
  }
  73% {
    transform: translateX(12px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
  86% {
    transform: translateX(0px) translateY(-12px) scale(1);
    animation-timing-function: linear;
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
`;
const rightExplode = keyframes`
   0% {
    transform: translateX(0px) translateY(0px) scale(1);
  }
  21% {
    transform: translateX(-8px) translateY(0px) scale(0.5);
    animation-timing-function: cubic-bezier(0.33,0,0,1);
  }
  34% {
    transform: translateX(-12px) translateY(-2px) scale(1);
    animation-timing-function: cubic-bezier(0,0,0,1);
  }
  47% {
    transform: translateX(-8px) translateY(-12px) scale(1);
    animation-timing-function: linear;
  }
  60% {
    transform: translateX(-8px) translateY(-8px) scale(1);
    animation-timing-function: linear;
  }
  73% {
    transform: translateX(-12px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
  86% {
    transform: translateX(0px) translateY(-12px) scale(1);
    animation-timing-function: linear;
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
`;

const leftTopExplode = keyframes`
  0% {
    transform: translateX(0px) translateY(0px) scale(1);
  }
  21% {
    transform: translateX(8px) translateY(0px) scale(0.5);
    animation-timing-function: cubic-bezier(0.33,0,0,1);
  }
  34% {
    transform: translateX(12px) translateY(2px) scale(1);
    animation-timing-function: cubic-bezier(0,0,0,1);
  }
  47% {
    transform: translateX(8px) translateY(12px) scale(1);
    animation-timing-function: linear;
  }
  60% {
    transform: translateX(8px) translateY(8px) scale(1);
    animation-timing-function: linear;
  }
  73% {
    transform: translateX(12px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
  86% {
    transform: translateX(0px) translateY(12px) scale(1);
    animation-timing-function: linear;
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
`;
const rightTopExplode = keyframes`
  0% {
    transform: translateX(0px) translateY(0px) scale(1);
  }
  21% {
    transform: translateX(-8px) translateY(0px) scale(0.5);
    animation-timing-function: cubic-bezier(0.33,0,0,1);
  }
  34% {
    transform: translateX(-12px) translateY(2px) scale(1);
    animation-timing-function: cubic-bezier(0,0,0,1);
  }
  47% {
    transform: translateX(-8px) translateY(12px) scale(1);
    animation-timing-function: linear;
  }
  60% {
    transform: translateX(-8px) translateY(8px) scale(1);
    animation-timing-function: linear;
  }
  73% {
    transform: translateX(-12px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
  86% {
    transform: translateX(0px) translateY(12px) scale(1);
    animation-timing-function: linear;
  }
  100% {
    transform: translateX(0px) translateY(0px) scale(1);
    animation-timing-function: linear;
  }
`;

const rightTopExplodeAnim = css`
  ${rightTopExplode}
`;
const leftTopExplodeAnim = css`
  ${leftTopExplode}
`;
const midExplodeAnim = css`
  ${midExplode}
`;
const topExplodeAnim = css`
  ${topExplode}
`;
const leftExplodeAnim = css`
  ${leftExplode}
`;
const rightExplodeAnim = css`
  ${rightExplode}
`;
const perfectWinBall = keyframes`
  0% {
    transform: scale(0);
    animation-timing-function: cubic-bezier(0.25,0.1,0.25,0.9);
  }
  28% {
    transform: scale(1.05);
    animation-timing-function: cubic-bezier(0.33,1.1,0.7,0.8);
  }
  62%, 100%{
    transform:  scale(1);
  }

`;
const perfectWinBG = keyframes`
 0%{
    animation-timing-function: cubic-bezier(0,0,.25,1);
    opacity:0;
  }
  20%{
    animation-timing-function: cubic-bezier(.2,.65,.2,0);
    opacity:0.5;
   }
  60%{
    opacity:0;
   } 
`;

const btnYellow = keyframes`
 0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
     transform:scale(1)
  }
  25%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform:scale(.65)
  }
  50%, 100%{
    transform:scale(1)
   } 
`;
const btnRed = keyframes`
  0%{
    /* animation-timing-function: cubic-bezier(.33,1,0,1); */
     transform:scale(1)
  }
  17% {
    animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    transform:scale(.65)
  }
  34% {
    transform:scale(1)
    animation-timing-function: cubic-bezier(0, 0, 0, 1);
  }
  51%{
    transform: translateX(0px);
    /* animation-timing-function: cubic-bezier(0.2,0.3,0.9,1.2); */
  }
  65% {
    transform: translateX(7px);
    animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);

  }
  79% {
    transform: translateX(-7px);
    animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
  }
  100%{
    transform: translateX(0px);
    animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
   } 
`;

const btnRedB = keyframes`
 0% {
      border-color: #ff3920;
      animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    50%,100% {
      border-color: #ff3920;

    }
`;
const btnYellowB = keyframes`
 0% {
      border-color: #ff3920;
      animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    50%,100% {
      border-color: #ffb000;
    }
`;

const btnYellowAnim = css`
  ${btnYellow}
`;
const btnYellowBAnim = css`
  ${btnYellowB}
`;
const btnRedAnim = css`
  ${btnRed}
`;
const btnRedBAnim = css`
  ${btnRedB}
`;
const perfectWinAnim = css`
  ${perfectWin}
`;
const perfectWinBallAnim = css`
  ${perfectWinBall}
`;
const perfectWinBGAnim = css`
  ${perfectWinBG}
`;
export const BallContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  grid-row-gap: 9px;
  grid-column-gap: 9px;
  margin: 32px auto;
  overflow: visible;
`;

export const AutoBall = styled.div`
  border-radius: 50%;
  width: 56px;
  height: 56px;
  position: relative;
  border: solid 3px;
  border-color: #233b50;
  span {
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
  }
  &&.R {
    background-color: #ff3920;
    border: none;
    animation: ${(p) => (p.autoAnimate ? btnRedAnim : null)};
    animation-duration: 0.483s;
    animation-fill-mode: forwards;
    span {
      animation: ${(p) => (p.autoAnimate ? whiteBgOnClickAnim : null)};
      animation-duration: 0.483s;
      animation-fill-mode: forwards;
    }
  }
  &&.Y {
    background-color: #ffb000;
    border: none;
    pointer-events: none;
    animation: ${(p) => (p.autoAnimate ? btnYellowAnim : null)};
    animation-duration: 0.483s;
    animation-fill-mode: forwards;
    span {
      animation: ${(p) => (p.autoAnimate ? whiteBgOnClickAnim : null)};
      animation-duration: 0.483s;
      animation-fill-mode: forwards;
    }
  }
  &&.YB {
    border: solid 3px;
    animation: ${btnYellowBAnim};
    animation-duration: 0.483s;
    animation-fill-mode: forwards;
  }
  &&.RB {
    border: solid 3px;
    animation: ${btnRedBAnim};
    animation-duration: 0.483s;
    animation-fill-mode: forwards;
  }
`;

export const ResultBall = styled.div`
  background: ${(p) => (p.isMine ? "#ff3920" : "#233b50")};
  border: solid 3px;
  border-color: ${(p) => (p.isMine ? "#ff3920" : "#233b50")};
  position: relative;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  .betReply {
    will-change: transform;
  }
  animation: ${(p) => {
    switch (true) {
      case p.isMine && p.mineLocation === "bot":
        return midExplodeAnim;
      case p.isMine && p.mineLocation === "top":
        return topExplodeAnim;
      case p.isMine && p.mineLocation === "left":
        return leftExplodeAnim;
      case p.isMine && p.mineLocation === "right":
        return rightExplodeAnim;
      case p.isMine && p.mineLocation === "leftTop":
        return leftTopExplodeAnim;
      case p.isMine && p.mineLocation === "rightTop":
        return rightTopExplodeAnim;
      case p.perfectWin:
        return perfectWinAnim;
      default:
        break;
    }
  }};
  animation-duration: ${(p) => (p.isMine || p.perfectWin ? "0.633s" : null)};
  animation-fill-mode: forwards;
  animation-delay: ${(p) => (p.del ? p.del : "0")}s;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    animation: ${(p) => (p.isMine || p.perfectWin ? perfectWinBGAnim : null)};
    animation-duration: ${(p) => (p.isMine || p.perfectWin ? "0.5s" : null)};
    animation-fill-mode: forwards;
  }
  span {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
  }
  span:nth-child(1) {
    width: 92%;
    height: 92%;
    background: ${(p) =>
      p.isMine ? "#ffb000" : p.perfectWin ? "#4099ba" : null};
    animation: ${(p) => (p.isMine || p.perfectWin ? perfectWinBallAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  span:nth-child(2) {
    width: 72%;
    height: 72%;
    background: ${(p) =>
      p.isMine ? "#ff3920" : p.perfectWin ? "#233b50" : null};
    animation: ${(p) => (p.isMine || p.perfectWin ? perfectWinBallAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-delay: 0.1s;
  }
  span:nth-child(3) {
    width: 52%;
    height: 52%;
    background: ${(p) =>
      p.isMine ? "#ffb000" : p.perfectWin ? "#4099ba" : null};
    animation: ${(p) => (p.isMine || p.perfectWin ? perfectWinBallAnim : null)};
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-delay: 0.2s;
  }
  span:nth-child(4) {
    width: 32%;
    height: 32%;
    background: ${(p) =>
      p.isMine ? "#ff3920" : p.perfectWin ? "#233b50" : null};
    animation: ${(p) => (p.isMine || p.perfectWin ? perfectWinBallAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-delay: 0s;
  }

  ${(p) => {
    switch (true) {
      case p.mineLocation === "rightTop":
        return `:nth-child(${p.ballsAround[0]}){animation: toLeft 0.5s linear forwards}
        :nth-child(${p.ballsAround[1]}){animation: toBot 0.5s 0.01s linear forwards};`;
      case p.mineLocation === "leftTop":
        return `:nth-child(${p.ballsAround[0]}){animation: toRight 0.5s linear forwards}
        :nth-child(${p.ballsAround[1]}){animation: toBot 0.5s linear forwards};`;
      case p.mineLocation === "right":
        return `:nth-child(${p.ballsAround[0]}){animation: toLeft 0.5s linear forwards}
        :nth-child(${p.ballsAround[1]}){animation: toTop 0.5s 0.01s linear forwards};`;
      case p.mineLocation === "left":
        return `:nth-child(${p.ballsAround[0]}){animation: toTop 0.5s  0.01s linear forwards}
        :nth-child(${p.ballsAround[1]}){animation: toRight 0.5s  linear forwards};`;
      case p.mineLocation === "top":
        return `:nth-child(${p.ballsAround[0]}){animation: toLeft 0.5s linear forwards}
        :nth-child(${p.ballsAround[1]}){animation: toRight 0.5s 0.01s linear forwards}`;
      case p.mineLocation === "bot":
        return `:nth-child(${p.ballsAround[0]}){animation toLeft 0.5s linear forwards}
        :nth-child(${p.ballsAround[1]}){animation: toTop 0.5s 0.01s linear forwards}
        :nth-child(${p.ballsAround[2]}){animation: toRight 0.5s 0.02s linear forwards}
        `;
      default:
        break;
    }
  }};
  &&.S {
    background-color: ${(p) => (!p.perfectWin ? "#ffb000" : "#233b50")};
    border-color: ${(p) => (!p.perfectWin ? "#ffb000" : "#233b50")};
    pointer-events: none;
    animation: ${(p) =>
      !p.perfectWin && !p.selectedAnimation
        ? btnYellowAnim
        : p.selectedAnimation
        ? "pulse"
        : "none"};
    animation-duration: 0.5s;
    animation-fill-mode: ${(p) => (p.selectedAnimation ? "unset" : "forwards")};
    animation-delay: ${(p) => (p.selectedAnimation ? "0.5s" : "0s")};
    animation-iteration-count: ${(p) => p.selectedAnimation && "infinite"};

    :after {
      animation: ${whiteBgOnClickAnim};
      animation-duration: 0.5s;
    }
    @keyframes pulse {
      0% {
        transform: scale(0.9);
      }
      70% {
        transform: scale(1);
      }
      100% {
        transform: scale(0.9);
      }
    }
  }
  &&.R {
    background-color: #ff3920;
    border-color: #ff3920;
    transition: all 0.5s cubic-bezier(0.33, 1, 0, 0);
    transition-property: background-color, border-color;
    transition-delay: ${(p) => (p.det ? p.del : "0")}s;
  }
  &&.Y {
    background-color: ${(p) => (!p.perfectWin ? "#ffb000" : "#233b50")};
    border-color: ${(p) => (!p.perfectWin ? "#ffb000" : "#233b50")};
    transition: all 0.5s cubic-bezier(0.33, 1, 0, 0);
    transition-property: background-color, border-color;
    transition-delay: ${(p) => (p.det ? p.del : "0")}s;
  }

  @keyframes toLeft {
    13% {
      transform: translateX(-10px);
    }
    30%,
    33% {
      transform: translateX(0px);
    }
    46% {
      transform: translateX(-10px);
    }
    60%,
    73% {
      transform: translateX(0px);
    }
    86% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0px);
    }
  }
  @keyframes toTop {
    13% {
      transform: translateY(-10px);
    }
    33% {
      transform: translateY(0px);
    }
    46% {
      transform: translateY(-10px);
    }
    60%,
    73% {
      transform: translateY(0px);
    }
    86% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  @keyframes toRight {
    13% {
      transform: translateX(10px);
    }
    30%,
    33% {
      transform: translateX(0px);
    }
    46% {
      transform: translateX(10px);
    }
    60%,
    73% {
      transform: translateX(0px);
    }
    86% {
      transform: translateX(10px);
    }
    100% {
      transform: translateX(0px);
    }
  }

  @keyframes toBot {
    13% {
      transform: translateY(10px);
    }
    33% {
      transform: translateY(0px);
    }
    46% {
      transform: translateY(10px);
    }
    60%,
    73% {
      transform: translateY(0px);
    }
    86% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;
export const Ball = styled.div`
  background: #233b50;
  border: solid 3px;
  border-color: #233b50;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
